import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import IntelligentHeader from "../IntelligentAllMajorModal/components/IntelligentHeader";
import "./style.css";
import "../../../../../index.css";
class IntelligentAdvanceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      visible,
      handleVisibleAdvanceModal,
      handleVisibleAdvanceMajorModal,
    } = this.props;
    return (
      <div
        className={
          visible === true
            ? "intelligentAdvanceModal_box"
            : "intelligentAdvanceModal_box display_none "
        }
      >
        <IntelligentHeader
          handleVisible={handleVisibleAdvanceModal}
        ></IntelligentHeader>
        <div className="intelligentAdvanceModal_title_box">
          <div style={{ height: 35, width: 10 }} className="fl"></div>
          <div className="fl">提前批</div>
        </div>
        <div className="intelligentAdvanceModal_data_box">
          <a onClick={() => handleVisibleAdvanceMajorModal(2025)}>
            2025年浙江省普通高校招生普通类提前录取分数
          </a>
          <a
            onClick={() => handleVisibleAdvanceMajorModal(2024)}
            style={{ marginTop: 13 }}
          >
            2024年浙江省普通高校招生普通类提前录取分数
          </a>
          <a
            onClick={() => handleVisibleAdvanceMajorModal(2023)}
            style={{ marginTop: 13 }}
          >
            2023年浙江省普通高校招生普通类提前录取分数
          </a>
          {/* <a
            onClick={() => handleVisibleAdvanceMajorModal(2022)}
            style={{ marginTop: 13 }}
          >
            2022年浙江省普通高校招生普通类提前录取分数
          </a> */}
          {/* <a
            onClick={() => handleVisibleAdvanceMajorModal(2019)}
            style={{ marginTop: 13 }}
          >
            2019年浙江省普通高校招生普通类提前录取分数
          </a> */}
          {/* <a
            onClick={() => handleVisibleAdvanceMajorModal(2018)}
            style={{ marginTop: 13 }}
          >
            2018年浙江省普通高校招生普通类提前录取分数
          </a> */}
        </div>
        <div className="intelligentAdvanceModal_tip_box">
          2026年浙江省普通高校招生普通类提前录取分数需要2027年高考季公布，届时会同步更新。
          <br></br>以上是统一公布的提前批数据，未统一公布的其他提前批数据见{" "}
          <NavLink to="/articledetail/e6aiwE">必读 | 提前批你需要懂</NavLink>
        </div>
        <div
          onClick={() => handleVisibleAdvanceModal()}
          className="intelligentAdvanceModal_button_box"
        >
          好 的
        </div>
      </div>
    );
  }
}

export default IntelligentAdvanceModal;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentAdvanceModal/index.js